export default function ListColumnBase() {
  const mapFilter = (
    filter: any,
    needFormat = false,
    formatFunction = null,
    isMyRequestCategory = false
  ) => {
    let filterList = [];
    if (filter && filter.length !== 0) {
      if (isMyRequestCategory) {
        filterList = filter.map((item: any) =>
          needFormat
            ? {
                // @ts-ignore
                text: formatFunction(item.name),
                // @ts-ignore
                value: formatFunction(item.name),
              }
            : {
                text: item.name,
                value: item.name,
              }
        );
      } else {
        filterList = filter.map((item: any) =>
          needFormat
            ? {
                // @ts-ignore
                text: formatFunction(item.name),
                // @ts-ignore
                value: formatFunction(item.id),
              }
            : {
                text: item.name,
                value: item.id,
              }
        );
      }
    }

    if (filterList.length > 0) {
      filterList.sort((a: any, b: any) => {
        const textA = a.text?.toUpperCase();
        const textB = b.text?.toUpperCase();

        if (textA == null && textB == null) return 0;
        if (textA == null) return -1;
        if (textB == null) return 1;

        return textA.localeCompare(textB);
      });
    }

    return filterList;
  };

  const handleFilteredValue = (value: any) => {
    return value || null;
  };

  const handleWidth = (isHide: any, width: any) => {
    return isHide ? 0 : width;
  };

  const handleTableSortOrder = (sortColumnName: any, tableSortData: any) => {
    if (tableSortData[0]?.sortColumn === sortColumnName) {
      return tableSortData[0].isAscending ? "ascend" : "descend";
    }
    return null;
  };

  const convertedFilter = (data: any) => {
    return data?.map(({ name, ...rest }: any) => ({
      ...rest,
      name: name === "true" ? "Yes" : "No",
    }));
  };

  const formatDateTime = (dateTimeString: any) => {
    const date = new Date(dateTimeString);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}`;
    return formattedDate;
  };

  const formatDate = (dateTimeString: any) => {
    if (dateTimeString === null) {
      return null;
    }
    const date = new Date(dateTimeString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  };

  const generateGUID = () => {
    // @ts-ignore
    let crypto = window.crypto || window.msCrypto;
    if (!crypto) {
      console.log("Crypto API not supported");
      return;
    }
    let buf = new Uint16Array(8);
    crypto.getRandomValues(buf);
    return (
      buf[0].toString(16) +
      buf[1].toString(16) +
      "-" +
      buf[2].toString(16) +
      "-" +
      buf[3].toString(16) +
      "-" +
      buf[4].toString(16) +
      "-" +
      buf[5].toString(16) +
      buf[6].toString(16) +
      buf[7].toString(16)
    );
  };

  return {
    mapFilter,
    handleFilteredValue,
    handleWidth,
    handleTableSortOrder,
    convertedFilter,
    formatDateTime,
    formatDate,
    generateGUID,
  };
}
